import React$1 from 'react';
import { classNames } from '../../../../utilities/css.js';
import { CaretDownMinor } from '@shopify/polaris-icons';
import { handleMouseUpByBlurring } from '../../../../utilities/focus.js';
import { Icon as Icon$1 } from '../../../Icon/Icon.js';
import { UnstyledLink as UnstyledLink$1 } from '../../../UnstyledLink/UnstyledLink.js';
import styles from './MenuAction.scss.js';

var _ref = /*#__PURE__*/React$1.createElement(Icon$1, {
  source: CaretDownMinor
});

function MenuAction({
  content,
  accessibilityLabel,
  url,
  external,
  icon,
  disclosure,
  disabled,
  onAction
}) {
  var iconMarkup = icon && /*#__PURE__*/React$1.createElement("span", {
    className: styles.IconWrapper
  }, /*#__PURE__*/React$1.createElement(Icon$1, {
    source: icon
  }));
  var disclosureIconMarkup = disclosure && /*#__PURE__*/React$1.createElement("span", {
    className: styles.IconWrapper
  }, _ref);
  var contentMarkup = iconMarkup || disclosureIconMarkup ? /*#__PURE__*/React$1.createElement("span", {
    className: styles.ContentWrapper
  }, iconMarkup, /*#__PURE__*/React$1.createElement("span", {
    className: styles.Content
  }, content), disclosureIconMarkup) : content;
  var menuActionClassNames = classNames(styles.MenuAction, disabled && styles.disabled);

  if (url) {
    return /*#__PURE__*/React$1.createElement(UnstyledLink$1, {
      className: menuActionClassNames,
      url: url,
      external: external,
      "aria-label": accessibilityLabel,
      onMouseUp: handleMouseUpByBlurring
    }, contentMarkup);
  }

  return /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    className: menuActionClassNames,
    disabled: disabled,
    "aria-label": accessibilityLabel,
    onClick: onAction,
    onMouseUp: handleMouseUpByBlurring
  }, contentMarkup);
}

export { MenuAction };
